module.exports = __webpack_public_path__ + "static/media/safe.a9344c8f.png";